import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";

import { Typography } from "../Typography";

import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";

import { resetCategoriesAndContactData } from "@/utils/feedbackPreviewNavigation";

import "./styles.scss";

export const FeedbackThankyou = ({ data }) => {
  const feedBackContext = useContext<QRFeedbackContextProps>(QRFeedbackContext);

  const { t } = useTranslation("feedback");
  const { themeColor } = data;

  useEffect(() => {
    if (feedBackContext) {
      feedBackContext.setSelectedReviewCategory({
        ...feedBackContext?.selectedReviewCategory,
        rating: null,
        comment: "",
      });
      feedBackContext.setRatingSelected(null);
      resetCategoriesAndContactData(feedBackContext);
      feedBackContext.setReviewContactData({
        name: "",
        email: "",
        phone: "",
      });
    }
  }, []);

  return (
    <div className="feedback-thankyou">
      <ReactSVG
        className="my-billing-dashboard__no-plans-image"
        src={`/svg/icon-alert.svg`}
      />

      <Typography
        Tag={"p"}
        spacing={2}
        classname="feedback-thankyou--title"
        style={{ color: themeColor.buttonColor }}
      >
        {t("thank_you_title")}
      </Typography>
      <Typography
        Tag={"p"}
        classname="feedback-thankyou--subtitle"
      >
        {t("thank_you_subtitle")}
      </Typography>
    </div>
  );
};
